import { snackbarType, colorType } from '@/vuex/modules/ui/snackbar/constants'

const switchTextColor = type => {
  switch (type) {
    case snackbarType.ERROR: {
      return 'white'
    }
    case snackbarType.SUCCESS: {
      return 'white'
    }
    default: {
      return 'pink'
    }
  }
}

const switchColor = type => {
  switch (type) {
    case snackbarType.DEFAULT: {
      return colorType.INFO
    }
    case snackbarType.SUCCESS: {
      return colorType.SUCCESS
    }
    case snackbarType.INFO: {
      return colorType.INFO
    }
    case snackbarType.ERROR: {
      return colorType.ERROR
    }
    default: {
      return 'Error'
    }
  }
}

const actions = {
  SHOW_SNACKBAR({ commit }, { type, message }) {
    const openFlag = true
    const color = switchColor(type)
    const textColor = switchTextColor(type)
    commit('SET_SNACKBAR', {
      openFlag,
      message,
      color,
      textColor,
    })
  },
  SHOW_SNACKBAR_DEFAULT({ dispatch }, message) {
    const type = snackbarType.DEFAULT
    dispatch('SHOW_SNACKBAR', { type, message })
  },
  SHOW_SNACKBAR_SUCCESS({ dispatch }, message) {
    const type = snackbarType.SUCCESS
    dispatch('SHOW_SNACKBAR', { type, message })
  },
  SHOW_SNACKBAR_INFO({ dispatch }, message) {
    const type = snackbarType.INFO
    dispatch('SHOW_SNACKBAR', { type, message })
  },
  SHOW_SNACKBAR_ERROR({ dispatch }, message) {
    const type = snackbarType.ERROR
    dispatch('SHOW_SNACKBAR', { type, message })
  },
  // close と reset は今の所内容が同じ
  CLOSE_SNACKBAR({ commit }) {
    const openFlag = false
    const message = ''
    const color = ''
    const textColor = ''

    commit('SET_SNACKBAR', {
      openFlag,
      message,
      color,
      textColor,
    })
  },
  RESET_SNACKBAR({ commit }) {
    const openFlag = false
    const message = ''
    const color = ''
    const textColor = ''

    commit('SET_SNACKBAR', {
      openFlag,
      message,
      color,
      textColor,
    })
  },
}

export default actions
